<!--
  Rodapé do modal "Ver detalhes". Ações lado a lado, cada uma com ícone, que é o
  padrão do repo pra
  rodapé de modal (ver `comissoes-add-spreads-sheet`, `task-detail-modal`) —
  `BaseSplitButton` é de toolbar de VIEW, não de rodapé.

  `Eventos` e `Movimentações` são as DUAS ações de adicionar (abrem o modal de
  cadastro com `origem: 'Manual'`), então carregam o MESMO ícone: ação igual,
  ícone igual. Ícone diferente em cada uma faz parecerem coisas diferentes.

  Rótulo no SINGULAR: cada uma adiciona UM lançamento por vez. O `+` é o
  próprio ícone, então o botão lê "+ Movimentação" sem repetir o sinal no
  texto. O mesmo rótulo vale pra ação do `BaseAlert` do modal.

  A raiz precisa ser flex: o `v-card__actions` do BaseModal é um flex row e este
  componente é UM item dele. Com raiz não-flex os botões viram bloco e empilham
  em coluna no canto do drawer, que era o defeito original.
-->
<script>
export default {
  name: 'AssetActionsFooter',
  props: {
    asset: {
      type: Object,
      required: true,
    },
    showSerieHistorica: {
      type: Boolean,
      default: false,
    },
    showEditAtivo: {
      type: Boolean,
      default: false,
    },
    showEditComposicao: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div class="asset-actions-footer">
    <BaseButton underlined @click="$emit('close')"> Voltar </BaseButton>
    <BaseButton
      v-if="showSerieHistorica"
      dark
      outline
      @click="$emit('open-serie-historica', asset)"
    >
      <icon-svg name="chart-grow" :size="16" />
      Série histórica
    </BaseButton>
    <BaseButton
      v-if="showEditAtivo"
      dark
      outline
      @click="$emit('edit-asset', asset)"
    >
      <icon-svg name="edit-pencil" :size="16" />
      Editar ativo
    </BaseButton>
    <BaseButton
      v-if="showEditComposicao"
      dark
      outline
      @click="$emit('edit-composicao', asset)"
    >
      <icon-svg name="mdi-clipboard-list-outline" :size="16" />
      Editar composição
    </BaseButton>
    <BaseButton dark outline @click="$emit('open-asset-events')">
      <icon-svg name="plus" :size="16" />
      Evento
    </BaseButton>
    <BaseButton primary @click="$emit('open-movimentacoes', asset)">
      <icon-svg name="plus" :size="16" />
      Movimentação
    </BaseButton>
  </div>
</template>

<style lang="sass" scoped>
.asset-actions-footer
  display: flex
  align-items: center
  flex-wrap: wrap
  gap: 12px
</style>
